@if (isOpen) {
  <div class="help-overlay" (click)="close()"></div>
  <aside class="help-drawer" role="dialog" aria-label="Help">
    <header class="help-drawer__head" [class.help-drawer__head--index]="showIndex">
      <div class="help-drawer__title">
        @if (showIndex) {
          <span class="help-drawer__badge" aria-hidden="true">?</span>
          <span class="help-drawer__heading">
            <span class="help-drawer__title-text">Help</span>
            <span class="help-drawer__subtitle">Choose a topic to get help with:</span>
          </span>
        } @else {
          @if (articles.length > 1) {
            <button
              type="button"
              class="help-drawer__icon-btn"
              (click)="openIndex()"
              title="All help topics"
              aria-label="All help topics"
            >
              <kendo-icon name="arrow-chevron-left"></kendo-icon>
            </button>
          }
          <span class="help-drawer__title-text">{{ title }}</span>
        }
      </div>
      <div class="help-drawer__actions">
        @if (!showIndex && fullPageUrl) {
          <a
            class="help-drawer__fullpage"
            [href]="fullPageUrl"
            target="_blank"
            rel="noopener noreferrer"
          >{{ 'helpOpenFullPage' | translate }}</a>
        }
        <button
          type="button"
          class="help-drawer__icon-btn"
          (click)="close()"
          aria-label="Close help"
        >
          <kendo-icon name="close"></kendo-icon>
        </button>
      </div>
    </header>

    <div class="help-drawer__body">
      @if (loading) {
        <div class="help-drawer__loading">
          <kendo-loader type="infinite-spinner" size="medium"></kendo-loader>
        </div>
      } @else if (showIndex) {
        <label class="help-drawer__search">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="11" cy="11" r="6.5"></circle>
            <line x1="16" y1="16" x2="20.5" y2="20.5"></line>
          </svg>
          <input
            type="search"
            [(ngModel)]="search"
            placeholder="Search help topics..."
            aria-label="Search help topics"
          />
        </label>
        @if (articles.length) {
          @if (visibleGroups.length) {
            @for (group of visibleGroups; track group.name) {
              <section class="help-drawer__group">
                <h2 class="help-drawer__group-label">
                  <app-svg-icon [name]="sectionIcon(group.name)" [size]="14" color="#98a2b3"></app-svg-icon>
                  <span>{{ group.name }}</span>
                </h2>
                <ul class="help-drawer__index">
                  @for (article of group.articles; track article.slug) {
                    <li>
                      <button type="button" class="help-drawer__topic" (click)="load(article)">
                        <span
                          class="help-drawer__glyph"
                          [style.background]="topicTone(article).background"
                          [style.color]="topicTone(article).color"
                        >
                          <app-svg-icon
                            [name]="topicIcon(article)"
                            [size]="16"
                            [color]="topicTone(article).color"
                          ></app-svg-icon>
                        </span>
                        <span class="help-drawer__topic-label">{{ article.title }}</span>
                        <kendo-icon name="arrow-chevron-right"></kendo-icon>
                      </button>
                    </li>
                  }
                </ul>
              </section>
            }
          } @else {
            <p class="help-drawer__intro">No matching topics.</p>
          }
        } @else {
          <p class="help-drawer__intro">{{ 'helpTopicsLoadFailed' | translate }}</p>
        }
      } @else {
        @if (articleFailed) {
          <p class="help-drawer__intro">{{ 'helpArticleLoadFailed' | translate }}</p>
        } @else {
          <article class="help-article" [innerHTML]="bodyHtml"></article>
        }
        @if (related.length) {
          <p class="help-drawer__intro">Also on this screen:</p>
          <ul class="help-drawer__index">
            @for (article of related; track article.slug) {
              <li>
                <button type="button" class="help-drawer__topic" (click)="load(article)">
                  <span
                    class="help-drawer__glyph"
                    [style.background]="topicTone(article).background"
                    [style.color]="topicTone(article).color"
                  >
                    <app-svg-icon
                      [name]="topicIcon(article)"
                      [size]="16"
                      [color]="topicTone(article).color"
                    ></app-svg-icon>
                  </span>
                  <span class="help-drawer__topic-label">{{ article.title }}</span>
                  <kendo-icon name="arrow-chevron-right"></kendo-icon>
                </button>
              </li>
            }
          </ul>
        }
      }
    </div>
  </aside>
}
